// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".paymentAlert__title[data-v-369d01e5]{color:#010d35;font-size:17px;font-weight:400;height:48px;justify-content:center;line-height:22px;margin-bottom:20px}.paymentAlert__buttons[data-v-369d01e5],.paymentAlert__title[data-v-369d01e5]{align-items:center;display:flex}.paymentAlert__buttons[data-v-369d01e5]>:first-child{margin-right:4px}.paymentAlert__buttons[data-v-369d01e5]>:last-child{margin-left:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
